import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivitySkydivingComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 18L12 22L16 18" fill="none" />
        <path d="M12 2V22" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconActivitySkydivingComponent.displayName = 'IconActivitySkydiving';

const IconActivitySkydiving = React.memo(IconActivitySkydivingComponent);

export default IconActivitySkydiving;
